<template>
  <div>
    <div class="pageContainer">
      <div
        class="bloc"
        :class="{
          'md-size-60 md-large-size-50 md-medium-size-40 md-small-size-25 md-xsmall-hide':
            details,
          'md-size-100': !details,
        }"
        style="width: 100%; margin-right: 20px"
      >
        <div class="ag-grid-div" :style="'height: ' + height + ';'">
          <ag-grid-vue
            oncontextmenu="return false;"
            style="width: 100%; height: 100%"
            id="ag-grid-sh"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :components="components"
            :rowBuffer="rowBuffer"
            :rowSelection="rowSelection"
            :rowDeselection="true"
            :rowModelType="rowModelType"
            :paginationPageSize="paginationPageSize"
            :cacheOverflowSize="cacheOverflowSize"
            :maxConcurrentDatasourceRequests="maxConcurrentDatasourceRequests"
            :infiniteInitialRowCount="infiniteInitialRowCount"
            :frameworkComponents="frameworkComponents"
            class="ag-theme-material"
          ></ag-grid-vue>
        </div>

        <div class="md-gutter md-layout md-alignment-top-left">
          <div class="md-layout-item">
            <span class="row-count light-gray-text">
              <pre><code><span>{{ currentRow }}/</span>{{ lastRow }}</code> {{ $t('results') }}</pre>
            </span>
          </div>
        </div>
      </div>

      <div
        class="md-layout-item bloc"
        :class="{
          'fake-hide': !details,
          'md-size-40 md-large-size-50 md-medium-size-60 md-small-size-75 md-xsmall-size-100':
            details,
        }"
      >
        <div :style="'height: ' + height + ';'">
          <div class="sh-details-box" :style="'height: calc(' + height + ');'">
            <div class="close-wrapper">
              <v-btn
                variant="text"
                @click="
                  details = false;
                  updateQuery();
                "
              >
                <svg-icon type="mdi" :path="pathMdiClose"></svg-icon>
              </v-btn>
            </div>
            <ShowerHeadDetails
              v-model:sh="detailed_sh"
              :sh_grid_bus="bus"
              :from_user="from_user"
            />
          </div>
        </div>
      </div>

      <!-- <v-dialog v-model="details" id="detailsDialog">
        <v-card>
          <v-card-title
            ><v-btn
              @click="
                details = false;
                updateQuery();
              "
            >
              <svg-icon type="mdi" :path="pathMdiClose"></svg-icon> </v-btn
          ></v-card-title>
          <v-card-text>
            <ShowerHeadDetails
              :sh="detailed_sh"
              :sh_grid_bus="bus"
              :from_user="from_user"
            />
          </v-card-text>
        </v-card>
      </v-dialog> -->
    </div>
    <v-snackbar :timeout="2000" v-model="copied" persistent>
      <span style="color: white">{{ $t("copied") }}</span>
    </v-snackbar>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import LastSeenRenderer from "../cellRenderers/LastSeenRenderer.vue";
import HeadersRenderer from "../cellRenderers/HeadersRenderer.vue";
import IconRenderer from "../cellRenderers/IconRenderer.vue";
import ShowerHeadTypeRenderer from "../cellRenderers/ShowerHeadTypeRenderer.vue";
import CodeRenderer from "../cellRenderers/CodeRenderer.vue";
import BatchRenderer from "../cellRenderers/BatchRenderer.vue";
import ThresholdRenderer from "../cellRenderers/ThresholdRenderer.vue";
import DisassociateButtonRenderer from "../cellRenderers/DisassociateButtonRenderer.vue";
import FlowRenderer from "../cellRenderers/FlowRenderer.vue";
import LabelRenderer from "../cellRenderers/LabelRenderer.vue";
import DetailButtonRenderer from "../cellRenderers/DetailButtonRenderer.vue";
import ShowerheadExpandRenderer from "../cellRenderers/ShowerheadExpandRenderer.vue";
import ShowerHeadDetails from "./ShowerHeadDetails.vue";
import mitt from "mitt";

import SvgIcon from "@jamescoyle/vue-icon";
import { mdiClose } from "@mdi/js";

export default {
  name: "ShowerheadsGrid",
  inject: ["$apiHydrao", "$global_error"],

  components: {
    "ag-grid-vue": AgGridVue,
    ShowerHeadDetails,
    SvgIcon,
  },
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      components: null,
      rowBuffer: null,
      rowSelection: null,
      rowModelType: null,
      paginationPageSize: null,
      cacheOverflowSize: null,
      maxConcurrentDatasourceRequests: null,
      infiniteInitialRowCount: null,
      frameworkComponents: null,

      lastEmail: null,
      currentRow: "-",
      lastRow: "-",
      lastSearch: null,
      searchTimeout: null,

      details: false,
      detailed_sh: null,

      first_fit: true,
      copied: false,
      skip_watch: false,
      selected_row: null,
      loaded: false,
      pathMdiClose: mdiClose,
      isGridDestroyed: false,
    };
  },
  props: {
    mode: null,
    params: null,
    bus: mitt(),
    from_user: null,
    height: {
      default: "100px",
    },
  },
  beforeMount() {
    this.gridOptions = {
      cacheBlockSize: 25,
      headerHeight: 25,
      suppressBrowserResizeObserver: true, // see https://github.com/ag-grid/ag-grid/issues/6562

      onBodyScroll: () => {
        if (!this.isGridDestroyed && this.gridApi) {
          let newCurrentRow = this.gridApi.getLastDisplayedRow() + 1;
          if (newCurrentRow != this.currentRow) {
            this.currentRow = newCurrentRow;
            if (this.mode == "all") this.updateQuery();
          }
        }
      },
      onSortChanged: () => {
        if (this.gridApi) {
          this.gridApi.ensureIndexVisible(0, "top");
          if (this.mode == "all") this.updateQuery();
        }
      },
      onFilterChanged: () => {
        if (this.gridApi) {
          this.gridApi.ensureIndexVisible(0, "top");
          if (this.mode == "all") this.updateQuery();
        }
      },
      onCellClicked: (params) => {
        this.detailed_sh = params.data;
        if (this.detailed_sh) this.detailed_sh.rowIndex = params.rowIndex;
        if (params.column.colId == "more") {
          this.details = true;
        }
        if (this.mode == "all" && this.details) this.updateQuery();
      },
      onPaginationChanged: () => {},
      onGridSizeChanged: (params) => {
        var grid_width = document.getElementById("ag-grid-sh").offsetWidth;
        if (grid_width) {
          var columnsToShow = ["label"];
          var columnsToHide = [
            "connectivity",
            "serial",
            "last_seen",
            "last_sync_date",
            "flow",
            "threshold",
            "email",
            "more",
            "disassociate",
          ];

          if (!this.details) {
            columnsToShow.push("more");
          }

          if (grid_width > 205) {
            columnsToShow.push("connectivity");
          }

          if (grid_width > 360) {
            columnsToShow.push("last_seen");
          }

          if (grid_width > 450) {
            columnsToShow.push("last_sync_date");
          }

          if (grid_width > 510) {
            columnsToShow.push("flow");
          }

          if (grid_width > 675) {
            columnsToShow.push("threshold");
          }

          if (grid_width > 800) {
            if (this.mode == "user") {
              columnsToShow.push("disassociate");
            } else if (this.mode == "all") {
              columnsToShow.push("email");
            }
          }

          if (grid_width > 900) {
            columnsToShow.push("serial");
          }

          params.columnApi.setColumnsVisible(columnsToShow, true);
          params.columnApi.setColumnsVisible(
            columnsToHide.filter((col) => !columnsToShow.includes(col)),
            false
          );

          if (this.first_fit) {
            this.first_fit = !this.first_fit;
          } else {
            params.api.sizeColumnsToFit();
          }
        }
      },
    };
    this.frameworkComponents = {
      lastSeenRenderer: LastSeenRenderer,
      headersRenderer: HeadersRenderer,
      iconRenderer: IconRenderer,
      showerHeadTypeRenderer: ShowerHeadTypeRenderer,
      codeRenderer: CodeRenderer,
      batchRenderer: BatchRenderer,
      thresholdRenderer: ThresholdRenderer,
      disassociateButtonRenderer: DisassociateButtonRenderer,
      flowRenderer: FlowRenderer,
      labelRenderer: LabelRenderer,
      detailButtonRenderer: DetailButtonRenderer,
      showerheadExpandRenderer: ShowerheadExpandRenderer,
    };
    this.columnDefs = [
      {
        headerName: "type",
        headerComponent: "headersRenderer",
        colId: "connectivity",
        valueGetter: (params) => {
          if (params.data) {
            return {
              type: params.data.type,
              connectivity: params.data.connectivity,
            };
          }
        },
        cellRenderer: "showerHeadTypeRenderer",
        minWidth: 75,
        maxWidth: 75,
      },
      {
        headerName: "label",
        headerComponent: "headersRenderer",
        colId: "label",
        valueGetter: (params) => {
          if (params.data) {
            return {
              label: params.data.label,
              uuid: params.data.device_uuid,
            };
          }
        },
        cellRenderer: "labelRenderer",
        onCellContextMenu: async (params) => {
          if (params.value) {
            console.log("params : ", params.value.label);
            params.value.label
              ? this.copyAndShowSnackbar(params.value.label)
              : this.copyAndShowSnackbar(params.value.uuid);
          }
        },
      },
      {
        headerName: "serial",
        field: "serial",
        headerComponent: "headersRenderer",
        cellRenderer: "codeRenderer",
        onCellContextMenu: async (params) => {
          if (params.value) {
            this.copyAndShowSnackbar(params.value);
          }
        },
      },
      {
        headerName: "batch_number",
        field: "batch_number",
        headerComponent: "headersRenderer",
        cellRenderer: "batchRenderer",
        onCellContextMenu: async (params) => {
          if (params.value) {
            this.copyAndShowSnackbar(params.value);
          }
        },
      },
      {
        headerName: "last_seen",
        field: "last_seen",
        headerComponent: "headersRenderer",
        cellRenderer: "lastSeenRenderer",
        sort: "desc",
        maxWidth: 110,
      },
      {
        headerName: "last_sync_date",
        headerComponent: "headersRenderer",
        colId: "last_sync_date",
        valueGetter: (params) => {
          if (params.data) {
            return {
              value: params.data.last_sync_date,
              color: params.data.is_last_sync_complete ? "good" : "bad",
            };
          }
        },
        cellRenderer: "lastSeenRenderer",
        maxWidth: 110,
      },
      {
        headerName: "flow",
        field: "flow",
        headerComponent: "headersRenderer",
        cellRenderer: "flowRenderer",
        maxWidth: 110,
      },
      {
        headerName: "threshold",
        field: "threshold",
        headerComponent: "headersRenderer",
        cellRenderer: "thresholdRenderer",
        sortable: false,
        minWidth: 106,
        maxWidth: 130,
      },
    ];
    if (this.mode == "user" && !isNaN(this.params.user_id)) {
      this.columnDefs.push({
        colId: "disassociate",
        headerName: "disassociate",
        valueGetter: (params) => {
          if (
            this.params.user_id &&
            params.data &&
            params.data.device_uuid &&
            this.params.email
          ) {
            return {
              user_id: this.params.user_id,
              email: this.params.email,
              device_uuid: params.data.device_uuid,
              gridReload: this.gridReload,
            };
          }
        },
        headerComponent: "headersRenderer",
        cellRenderer: "disassociateButtonRenderer",
        sortable: false,
        minWidth: 100,
        maxWidth: 300,
      });
    }
    if (this.mode == "all") {
      this.columnDefs.push({
        colId: "email",
        headerName: "email",
        headerComponent: "headersRenderer",
        cellRenderer: "detailButtonRenderer",
        valueGetter: (params) => {
          if (params.data && params.data.email) {
            return {
              value: params.data.email,
              show_email: true,
            };
          }
        },
        sortable: false,
        minWidth: 140,
      });
    }
    this.columnDefs.push({
      headerName: "",
      colId: "more",
      field: "device_uuid",
      cellRenderer: "showerheadExpandRenderer",
      sortable: false,
      minWidth: 55,
      maxWidth: 55,
    });

    this.defaultColDef = {
      flex: 1,
      resizable: true,
      sortable: true,
      suppressMovable: true,
    };
    this.components = {};
    this.rowBuffer = 0;
    this.rowSelection = "single";
    this.rowModelType = "infinite";
    this.paginationPageSize = 25;
    this.cacheOverflowSize = 1;
    this.maxConcurrentDatasourceRequests = 1;
    this.infiniteInitialRowCount = 1;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    if (this.bus) {
      this.bus.on("shGridRefresh", () => {
        //reload the grid
        this.gridReload();
      });
      this.bus.on("searchCalled", () => {
        clearTimeout(this.searchTimeout);
        this.gridApi.onFilterChanged();
      });
      this.bus.on("searchInit", () => {
        clearTimeout(this.searchTimeout);
        this.gridApi.onFilterChanged();
        this.skip_watch = true;
      });
      this.bus.on("refreshAfterDissociate", () => {
        //reload the grid
        this.gridReload();
      });
    }
    if (this.mode == "all") this.handleQuery();
  },
  watch: {
    loaded() {
      if (
        this.gridApi &&
        this.selected_row != null &&
        this.mode == "all" &&
        this.details
      ) {
        let node = this.gridApi.getRowNode(this.selected_row + "");
        if (node) {
          node.setSelected(true);
          this.detailed_sh = node.data;
          this.detailed_sh.rowIndex = this.selected_row;
          this.selected_row = null;
          this.updateQuery();
        } else {
          this.loaded = false;
        }
      }
    },
    params() {
      if (this.mode == "user" && this.lastEmail != this.params.email) {
        this.lastEmail = this.params.email;
        if (this.gridApi) {
          this.gridApi.onFilterChanged();
        }
      }
      if (this.mode == "user" && !isNaN(this.params.user_id)) {
        this.gridApi.refreshCells({ columns: ["disassociate"], force: false });
      }
      if (this.mode == "all" && this.lastSearch != this.params.search) {
        this.lastSearch = this.params.search;
        if (this.gridApi && !this.skip_watch) {
          clearTimeout(this.searchTimeout);
          this.searchTimeout = setTimeout(() => {
            this.gridApi.onFilterChanged();
          }, 1000);
        }
        if (this.skip_watch) this.skip_watch = false;
      }
    },
  },
  methods: {
    destroyGrid() {
      if (this.gridApi) {
        this.gridApi.destroy();
        this.isGridDestroyed = true;
      }
    },
    copyAndShowSnackbar(value) {
      navigator.clipboard.writeText(value).then(
        () => {
          this.copied = true;
        },
        (error) => {
          console.error("Could not copy text: ", error);
        }
      );
    },
    getQueryRow() {
      return this.query_row;
    },
    setQueryRow(value) {
      this.query_row = value;
    },
    getSelectedRow() {
      return this.loaded;
    },
    setLoaded(value) {
      this.loaded = value;
    },
    handleQuery() {
      let query = this.$route.query;
      if (query.s && query.d) {
        this.gridApi.setSortModel([{ colId: query.s, sort: query.d }]);
      }
      if (query.r && query.m == null) {
        this.setQueryRow(query.r);
      }
      if (query.m != null) {
        this.setQueryRow(query.m);
        this.details = true;
        this.selected_row = query.m;
      }
    },
    updateQuery() {
      if (this.gridApi) {
        let query = {};
        if (this.gridApi.getFirstDisplayedRow()) {
          query.r = this.gridApi.getFirstDisplayedRow();
        }
        // if (
        // this.gridApi.sortModel() &&
        //  this.gridApi.sortModel()[0] &&
        //  this.gridApi.sortModel()[0].colId &&
        // this.gridApi.sortModel()[0].sort
        //) {
        //  query.s = this.gridApi.sortModel()[0].colId;
        //   query.d = this.gridApi.sortModel()[0].sort;
        //  }
        if (this.getSearch()) {
          let trimed = this.getSearch();
          trimed = trimed.trim();
          query.q = window.btoa(unescape(encodeURIComponent(trimed)));
        }
        if (
          this.details &&
          this.detailed_sh &&
          this.detailed_sh.rowIndex != null
        ) {
          query.m = this.detailed_sh.rowIndex;
        }

        this.$router
          .replace({
            ...this.$router.currentRoute,
            query: query,
          })
          .catch(() => {});
      }
    },
    getDataSource() {
      var gridApi = this.gridApi;
      const apiHydrao = this.$apiHydrao;
      var getUserEmail = this.getUserEmail;
      var refresh = false;
      var fields = null;
      if (this.mode == "user") {
        refresh = true;
        fields = [
          "device_uuid",
          "serial",
          "first_seen",
          "last_seen",
          "last_sync_date",
          "threshold",
          "label",
          "type",
          "is_last_sync_complete",
          "connectivity",
          "flow",
          "mac_address",
          "ref_shower_duration",
          "previous_flow",
          "calibration",
          "hw_version",
          "fw_version",
          "threshold_request",
          "batch_number",
        ];
      } else if (this.mode == "all") {
        fields = [
          "device_uuid",
          "serial",
          "first_seen",
          "last_seen",
          "last_sync_date",
          "threshold",
          "label",
          "type",
          "is_last_sync_complete",
          "connectivity",
          "flow",
          "mac_address",
          "ref_shower_duration",
          "previous_flow",
          "calibration",
          "hw_version",
          "fw_version",
          "threshold_request",
          "email",
          "user_id",
          "batch_number",
        ];
      }
      var setLastRow = this.setLastRow;
      var global_error = this.$global_error;
      var getSearch = this.getSearch;
      var getQueryRow = this.getQueryRow;
      var setQueryRow = this.setQueryRow;
      var setLoaded = this.setLoaded;
      var getSelectedRow = this.getSelectedRow;

      return {
        rowCount: null,
        getRows: async function (params) {
          let limit = params.endRow - params.startRow;
          let offset = params.startRow;
          let sortModel = {
            colId: null,
            sort: null,
          };
          if (params.sortModel[0]) {
            sortModel.colId = params.sortModel[0].colId;
            sortModel.sort = params.sortModel[0].sort;
          }
          var data_length;

          var rowsThisPage;
          let trimed = getSearch();
          if (trimed) trimed = trimed.trim();
          try {
            let result = await apiHydrao.getShowerHeadsData(
              limit,
              offset,
              sortModel,
              getUserEmail(),
              trimed,
              fields,
              refresh
            );

            if (!result) {
              global_error.newError("Error : no results");
              params.failCallback();
              return;
            } else if (!result.data || !result.headers) {
              if (
                result.response &&
                result.response.data &&
                result.response.data.error
              ) {
                global_error.newError(
                  result.response.data.error +
                    ": " +
                    result.response.data.message
                );
              } else {
                global_error.newError(result);
              }
              params.failCallback();
              return;
            }
            rowsThisPage = result.data;
            // amount of matching row in the database
            data_length = result.headers["content-range"].split("/")[1];
            //tell the grid how many rows we'll be sending so i dont scroll past the last row

            if (!this.isGridDestroyed && !this.gridApi) {
              gridApi.setRowCount(data_length, true);
            }
          } catch (e) {
            global_error.newError(e);
            params.failCallback();
            return;
          }

          setLastRow(data_length);
          /*  if (gridApi.getInfiniteRowCount() < data_length) {
            gridApi.setInfiniteRowCount(data_length, false);
          }*/
          if (getQueryRow()) {
            gridApi.ensureIndexVisible(parseInt(getQueryRow()), "top");
            setQueryRow(null);
          }
          if (getSelectedRow() != null) {
            setLoaded(true);
          }

          var agLastRow = -1;
          if (data_length <= params.endRow) {
            agLastRow = data_length;
          }

          params.successCallback(rowsThisPage, agLastRow);
        },
      };
    },
    onGridReady() {
      this.isGridDestroyed = false;
      this.gridReload();
    },
    gridReload() {
      this.gridApi.setDatasource(this.getDataSource());
    },
    setLastRow(value) {
      this.lastRow = value;
      if (!this.isGridDestroyed && this.gridApi) {
        this.currentRow = Math.min(
          this.gridApi.getLastDisplayedRow() + 1,
          value
        );
      }
    },
    getUserEmail: function () {
      return this.lastEmail;
    },
    getSearch() {
      return this.lastSearch;
    },
  },
  i18n: {
    messages: {
      en: {
        no_sh: "No shower heads",
        results: "results",
        copied: "Cell copied",
      },
      fr: {
        no_sh: "Aucun pommeau",
        results: "résultats",
        copied: "Case copiée",
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.pageContainer {
  display: flex;
  flex-direction: row;
}

.ag-header-row {
  height: 24px !important;
}

.ag-header {
  min-height: 30px !important;
  height: 30px !important;
}

span {
  color: #545454;
}

.row-count {
  float: right;
  span {
    color: #c4c4c4;
  }
}

.close-header {
  width: 100%;
  height: 26px;

  i {
    float: right;
  }
}

.sh-details-box {
  // background-color: white;
  overflow: auto;

  .v-btn {
    text-align: right;
  }
}

.fake-hide {
  display: none;
}

.bloc {
  width: 70%;
  transition: 0.1s;
}
</style>

<style>
div .ag-cell {
  color: #545454;
}

#detailsDialog {
  width: 50%;
}

.ag-grid-div {
  margin-left: 20px;
  margin-bottom: 20px;
}

.close-wrapper {
  width: 100%;
  text-align: right;
}
</style>
